import { LucideIcon, Sliders } from "lucide-react";
import {
  LayoutDashboard,
  User,
  BadgeCheck,
  Shield,
} from "lucide-react";

export interface NavLinkItem {
  id: string;
  to: string;
  label: string;
  icon: LucideIcon;
}

export const navLinks: NavLinkItem[] = [
  {
    id: "dashboard",
    to: "/dashboard",
    label: "Tableau de bord",
    icon: LayoutDashboard,
  },
  {
    id: "profile",
    to: "/profile",
    label: "Mon profil",
    icon: User,
  },
  {
    id: "identity",
    to: "/identity",
    label: "Identité",
    icon: BadgeCheck,
  },
  {
    id: "security",
    to: "/security",
    label: "Sécurité",
    icon: Shield,
  },
{
  id: "preferences",
  to: "/preferences",
  label: "Préférences",
  icon: Sliders,
}
 
];